<template>
    <v-app style="background-color:white;margin-top:45px;margin-bottom:45px;">
        <router-view></router-view>
        <!-- LOADING FULL -->
        <v-dialog v-model="$store.getters.loading" persistent max-width="200px">
            <v-card color="primary" dark>
                <v-card-text class="text-xs-center">
                    Aguarde
                    <v-progress-linear indeterminate color="white" class="my-3"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<style>
.v-sheet,
.v-toolbar__content {
    width: 100%;
}
</style>
<script>
export default {
    name: "App",
    components: {},
    data: () => ({
        //
    }),
    created(){
        this.$store.dispatch("loading_full", false);
    },
    beforeCreate: function() {
        /**
         * Verificamos se a url atual está dentro do dashboard, caso esteja o usuário deve
         * estar logado, caso contrário é redirecionado para a inicial HOME
         */
        var router_items = this.$router.match(location.pathname);
        
        if (router_items.fullPath.indexOf("dashboard") >= 0) {
            if (!this.$store.getters.is_loggedin) {
                this.$router.push({ path: "/" });
                return;
            }
        }
    },
    methods: {
        goLogin() {
            return this.$route.push({ name: "login" });
        }
    }
};
</script>
